import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import IndiaCorridor from "@/components/IndiaCorridor";
import { HERO_IMAGE } from "@/lib/site-data";

const HUBS = [
    { name: "Waluj, Aurangabad", role: "Anchor warehouse + HQ", code: "AUR" },
    { name: "Chakan, Pune", role: "Plant-side operations", code: "PNQ" },
    { name: "Mumbai (BOM)", role: "Port & ICD corridor", code: "BOM" },
    { name: "Nashik", role: "Component aggregation", code: "NSK" },
    { name: "Ahmedabad", role: "Western dispatch hub", code: "AMD" },
    { name: "Nagpur", role: "Central India corridor", code: "NAG" },
    { name: "Bengaluru", role: "Southern auto cluster", code: "BLR" },
    { name: "Chennai", role: "Southern port corridor", code: "MAA" },
];

export default function NetworkPage() {
    return (
        <div data-testid="page-network">
            <PageHeader
                overline="Network"
                title="Pune ↔ Aurangabad. The industrial corridor we own."
                subtitle="Owned operations on India's busiest auto belt — and pan-India coverage through Vibhuti Transways Combines."
                image={HERO_IMAGE}
                breadcrumb={[{ label: "Network" }]}
                testId="network-header"
            />

            <section className="bg-white py-20" data-testid="network-map-section">
                <div className="container-vl grid grid-cols-12 gap-10 items-start">
                    <div className="col-span-12 lg:col-span-8">
                        <div className="bg-[#F8FAFC] border border-[#CBD5E1] p-4 md:p-6">
                            <IndiaCorridor testId="network-page-map" />
                        </div>
                    </div>
                    <div className="col-span-12 lg:col-span-4 space-y-6">
                        <div className="bg-[#28406A] text-white p-7">
                            <p className="overline mb-2 text-[#F4A000]">Core Corridor</p>
                            <p className="font-display uppercase text-2xl">Pune ↔ Aurangabad</p>
                            <p className="text-sm text-[#CBD5E1] mt-3">Owned warehouses & dedicated fleet at both ends — daily milk-runs and emergency JIT support.</p>
                        </div>
                        <div className="bg-[#E9EEF3] p-7 border-l-4 border-[#F4A000]">
                            <p className="overline mb-2">Pan-India</p>
                            <p className="font-display uppercase text-xl text-[#101A2C]">Vibhuti Transways Combines</p>
                            <p className="text-sm text-[#4B6390] mt-3">Trusted combine network for nationwide FTL and ODC movements with single-window coordination.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-[#F8FAFC] py-20 border-y border-[#CBD5E1]" data-testid="network-hubs">
                <div className="container-vl">
                    <p className="overline mb-4">Operational Hubs</p>
                    <h2 className="heading-h2 text-[#101A2C] mb-12 max-w-3xl">Where we work directly — and where we partner.</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        {HUBS.map((h, i) => (
                            <div key={h.name} className="bg-white border border-[#CBD5E1] p-5 hover:border-[#28406A] hover:shadow-[4px_4px_0_#28406A] transition-all" data-testid={`hub-${h.code.toLowerCase()}`}>
                                <p className="font-mono text-xs text-[#F4A000] tracking-widest">[ {h.code} ]</p>
                                <h3 className="font-display uppercase text-lg text-[#101A2C] mt-2 flex items-center gap-1">
                                    <MapPin className="h-4 w-4 text-[#28406A]" strokeWidth={1.5} /> {h.name}
                                </h3>
                                <p className="text-xs text-[#4B6390] mt-2">{h.role}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="bg-[#F4A000] py-16" data-testid="network-cta">
                <div className="container-vl flex flex-col md:flex-row md:items-center justify-between gap-6">
                    <h3 className="heading-h3 text-[#101A2C] max-w-2xl">Operating on a specific corridor? Let's design a route plan for you.</h3>
                    <Link to="/contact" data-testid="network-cta-btn" className="btn-navy">
                        Plan My Route <ArrowRight className="h-4 w-4" />
                    </Link>
                </div>
            </section>
        </div>
    );
}
